import colors from "vuetify/es5/util/colors";
export default {
  name: "Default-light",
  dark: false,
  scheme: "md-deep-purple-a700-scheme",
  primary: colors.deepPurple.base
};
